import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getMessage } from '../../reducers/i18n';
import ShippingCostDialog from '../addtocart/ShippingCostDialog';
import Heading from '../heading/Heading';

const PriceDisplay = props => {

    const PriceDisplay = styled.div`
        font-weight: 600;
        margin-top: 0.31em;
    `;

    const PriceSuffix = styled.div`
        display: flex;
        font-size: ${props => props.theme.fontSizes[7]};
        flex-wrap: wrap;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        margin-right: ${props => props.theme.space[6]};

        & button {
          box-sizing: border-box;
          text-transform: none;
          padding: ${props => props.theme.space[2]};
          min-height: inherit;
        }

        & .stolo-price-suffix {
          padding: ${props => props.theme.space[2]} 0;
        }

        & .stolo-price-suffix-first {
          padding-right: ${props => props.theme.space[2]};
        }
    `;

    const StyledDialogHeader = styled(Heading)`
        margin: 0;
        padding: 0;
    `;

    const DialogHeader = (<StyledDialogHeader
        level={2}
        text={props.shippingCostLabel}
    />);

    const ShippingLabel = props.shippingIncluded === true ? (<div
        className='stolo-price-suffix'
    >{props.shippingIncludedSuffix}</div>) :
    (<ShippingCostDialog
        key='s3'
        label={`${props.shippingCostLabelPrefix} ${
                            props.shippingCostLabel}`} header={DialogHeader}
        close={props.labelClose}
    />);

    const VatSuffix = props.showVat === true ? (<div
        className='stolo-price-suffix stolo-price-suffix-first'
        key='s2'
    >
        {props.vatPriceSuffix}
    </div>) : null;

    const priceSuffix = [
        <PriceSuffix key='s1'>
            {VatSuffix}{ShippingLabel}
        </PriceSuffix>];

    const Price = `${props.amount.toFixed(2)}&nbsp;${props.currencyUnit}`;

    return (
        <div>
            <PriceDisplay dangerouslySetInnerHTML={{ __html: Price }} />
            {priceSuffix}
        </div>
    );
};

PriceDisplay.propTypes = {
    label: PropTypes.string,
    currencyUnit: PropTypes.string,
    amount: PropTypes.number,
    shippingIncluded: PropTypes.bool,
    showVat: PropTypes.bool,
};

PriceDisplay.defaultProps = {
    label: '',
    currencyUnit: '€',
    amount: 999.99,
    shippingIncluded: false,
    showVat: true,
};

const mapStateToProps = (state, ownProps) => ({
    vatPriceSuffix: getMessage(state, 'VAT_PRICE_SUFFIX'),
    shippingCostLabel: getMessage(state, 'SHIPPING_COST_LABEL'),
    shippingCostLabelPrefix: getMessage(state,
            'SHIPPING_COST_LABEL_PREFIX',
        ),
    shippingIncludedSuffix: getMessage(state, 'SHIPPING_INCLUDED_LABEL'),
    labelClose: getMessage(state, 'LABEL_CLOSE'),
    ...ownProps,
});

export default connect(mapStateToProps)(PriceDisplay);



// WEBPACK FOOTER //
// ./src/components/cartforms/PriceDisplayWithHeading.js